import React from "react";
import { useCardSelector } from "../../common/CardSelectorProvider";
import { FaTrash } from "react-icons/fa";
import TopicCard from "../../topics/TopicCard";
import PersonaCard from "../../persona/PersonaCard";
import { extractValidationVariables } from "../../../utils/topicHelper";
import { MdDescription } from "react-icons/md";
import { renderIcon, topicIcon } from "../../common/IconLibrary";
import usePins from "../../../hooks/usePins";

const PresentationConfigItem = ({
  configuration,
  topics,
  personas,
  onUpdate,
  onDelete,
}) => {
  const { openCardSelector } = useCardSelector();
  const { sortPinnedFirst: sortTopics } = usePins("topics");
  const { sortPinnedFirst: sortPersonas } = usePins("personas");

  const handlePersonaChange = async () => {
    openCardSelector({
      items: sortPersonas(personas, (p) => p.id),
      CardComponent: PersonaCard,
      title: "Select a Different Persona",
      onSelect: (selectedPersona) => {
        onUpdate({ ...configuration, persona: { id: selectedPersona.id } });
      },
    });
  };

  const handleTopicChange = async () => {
    openCardSelector({
      items: sortTopics(topics, (t) => t.key),
      CardComponent: TopicCard,
      title: "Select a Different Topic",
      onSelect: (selectedTopic) => {
        onUpdate({
          ...configuration,
          topic: {
            name: selectedTopic.name,
            description: selectedTopic.description,
            id: selectedTopic.id,
            key: selectedTopic.key,
            version: selectedTopic?.version || 0,
            variables: extractValidationVariables(selectedTopic),
          },
        });
      },
      highlightVersions: ["Presentation"],
    });
  };

  const handleVariablesChange = (e) => {
    const cfg = JSON.parse(JSON.stringify(configuration));
    cfg.topic.variables = e.target.value;
    onUpdate(cfg);
  };

  const handleNameChange = (e) => {
    const cfg = JSON.parse(JSON.stringify(configuration));
    cfg.topic.name = e.target.value;
    onUpdate(cfg);
  };

  const handleDescriptionChange = (e) => {
    const cfg = JSON.parse(JSON.stringify(configuration));
    cfg.topic.description = e.target.value;
    onUpdate(cfg);
  };

  return (
    <div className="flex items-center gap-4 mb-4 bg-gray-700 p-4 rounded">
      <div className="flex-1 flex flex-col">
        <div className="relative">
          <span className="absolute left-2 top-3 text-gray-400">
            {renderIcon(topicIcon, 18, 18)}
          </span>{" "}
          <input
            type="text"
            value={configuration.topic.name || ""}
            onChange={handleNameChange}
            placeholder="Title"
            className="w-full pl-8 p-2 bg-gray-900/30 text-white rounded mb-4"
          />
        </div>
        <div className="relative">
          <MdDescription className="absolute left-2 top-3 text-gray-400" />
          <textarea
            value={configuration.topic.description || ""}
            onChange={handleDescriptionChange}
            placeholder="Description"
            className="w-full pl-8 p-2 bg-gray-900/30 text-white rounded h-[243px] dark-slim-scrollbar resize-none"
          />
        </div>
      </div>
      <div className="flex-1">
        {configuration &&
          configuration.persona &&
          personas.find((p) => p.id === configuration.persona.id) && (
            <PersonaCard
              item={personas.find((p) => p.id === configuration.persona.id)}
              onClick={() => {}}
              height={280}
            />
          )}
        <button
          onClick={handlePersonaChange}
          className="w-full p-1 bg-gray-600 text-white rounded text-center text-xs mt-2 hover:bg-gray-500"
        >
          Change Persona
        </button>
      </div>
      <div className="flex-1">
        {configuration &&
          configuration.topic &&
          topics.find((t) => t.key === configuration.topic.key) && (
            <TopicCard
              item={topics.find((t) => t.key === configuration.topic.key)}
              onClick={() => {}}
              height={280}
              highlightVersions={["Presentation"]}
            />
          )}
        <button
          onClick={handleTopicChange}
          className="w-full p-1 bg-gray-600 text-white rounded text-center text-xs mt-2 hover:bg-gray-500"
        >
          Change Topic
        </button>
      </div>
      <div className="flex-1 flex flex-col">
        {configuration && (
          <input
            type="text"
            value={`Version ${configuration.topic.version || ""}`}
            onChange={handleNameChange}
            placeholder="Title"
            className="w-full pl-8 p-2 bg-gray-900/30 text-white rounded mb-4"
            readOnly
          />
        )}
        <textarea
          value={configuration.topic.variables || ""}
          onChange={handleVariablesChange}
          placeholder="Enter variables (comma-separated)"
          className="p-2 bg-[#1F1F1F] text-gray-200 rounded-sm font-mono w-full h-[270px] dark-slim-scrollbar resize-none"
        />
      </div>
      <button
        onClick={onDelete}
        className="text-white p-2 rounded-2xl hover:bg-red-600"
      >
        <FaTrash />
      </button>
    </div>
  );
};

export default PresentationConfigItem;
